<template>
  <div>
    <AbadonedCartList />
  </div>
</template>

<script>
import AbadonedCartList from "@/components/Common/AbadonedCartList.vue";
export default {
  components: {
    AbadonedCartList
  }
};
</script>

<style lang="scss" scoped></style>
